import { CopiedBlockClipType } from "@pathwright/blocks-engine"
import PasteButton from "@pathwright/ui/src/components/button/PasteButton"
import { useBlocksConfig } from "@pathwright/blocks-engine"
import PropTypes from "prop-types"

type PasteBlockButtonProps = {
  onPaste: (index: number, copies?: number) => void | Promise<void>
  index: number
  onCancel: () => void
  copiedBlock?: CopiedBlockClipType
  style?: React.CSSProperties
  pasting?: boolean
  error?: string
}

const PasteBlockButton = (props: PasteBlockButtonProps) => {
  const { copiedBlock, onPaste, index, onCancel, style, pasting, error } = props

  const { isSuperuser } = useBlocksConfig()
  const handlePaste = (clip: CopiedBlockClipType, copies?: number) =>
    onPaste(index, copies)

  // Don't show the button if there's nothing to paste
  if (!copiedBlock) return null

  return (
    <PasteButton
      clip={copiedBlock}
      onPaste={handlePaste}
      allowMultiplePaste={!!isSuperuser}
      onCancel={onCancel}
      style={style}
      styleMode="light"
      pasting={pasting}
      error={error}
    />
  )
}

PasteBlockButton.propTypes = {
  index: PropTypes.number,
  onPaste: PropTypes.func.isRequired, // Async upstream handler handler that calls the pasteBlock mutation
  onCancel: PropTypes.func.isRequired,
  copiedBlock: PropTypes.object,
  style: PropTypes.object,
  error: PropTypes.string
}

export default PasteBlockButton
